export var SceneColor;
(function (SceneColor) {
    SceneColor["Aqua"] = "#44EFBC";
    SceneColor["Yellow"] = "#F8E219";
    SceneColor["Blue"] = "#2079FF";
    SceneColor["Magenta"] = "#E51BAC";
    SceneColor["Purple"] = "#B33DFB";
    SceneColor["Lime"] = "#00D957";
})(SceneColor || (SceneColor = {}));
